/// <reference path="../../angular.js" />
/// <reference path="../../jquery-1.8.2.js" />

/// <reference path="main.js" />
'use strict';
angular.module('EMR.Session').factory('SessionService', ['$', '$rootScope', '$window', function ($, $rootScope, $window) {
    var proxy;
    var connection;
    return {
        connect: function () {
            //connection = $.hubConnection(EMRApplicationPath);
            //proxy = connection.createHubProxy('sessionHub');
            //connection.start().then(function () {              
            //    $.get(EMRApplicationPath + 'Home/SaveConnectionId?conn=' + proxy.connection.id);
            //});
            //proxy.on('noteAdded', function (note) {
            //    $rootScope.$broadcast('noteAdded', note);
            //});

            //proxy.on('sessionExpired', function (args) {
            //    $rootScope.$broadcast('logout');
            //    console.log(args);
            //    $window.location.href = EMRApplicationPath + 'SessionOut/SessionOut'; //SESSION TIMEOUT
            //});
        },
        isConnecting: function () {
            return connection.state === 0;
        },
        isConnected: function () {
            return connection.state === 1;
        },
        connectionState: function () {
            return connection.state;
        },
        addNote: function (note) {
            proxy.invoke('addNote', note);
        },
    }
}]);


//############## SIGNAL- R CONNECTION ESTABLISHMENTS AND EVENT RAISING  BLOCK STARTS ##########################
//*******PURPOSE: this method is useful in starting the signalr service for getting all the notifications from the server to notify to user
//*******CREATED BY: Mahesh P
//*******CREATED DATE: 07/15/2015
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx    

angular.module('EMR.Session').factory('EMRApplicationHubService', ['$rootScope', function ($rootScope) {


    //signalr hub factory function that establishes the connection
    function signalrHubFactory() {

        //for latest version
        //var connection = $.hubConnection(backendServerUrl);
        //var proxy = connection.createHubProxy(hubName);

        //getting the constant url from the controller requested
        //emrAppicationSignalrURL//emrCommonCentralizerSignalrURL

        var connection;
        var proxy;
        var connectionCount = 0;//connection established count

        var connectionState = { connecting: 0, connected: 1, reconnecting: 2, disconnected: 4 };//connection state of the Signal R while publishing the message 
        var notstoppedmanually = true;

        var emrApplicationHubRequests = [];//this is used to maintain the user data that has requested queee if the signalr has lost it's connection 

        //this method is useful in establishing the connection to the signalr server 
        function establishConnection() {
            //added by mahesh p on 03/18/2015 since signal R has destroyed for web version
            return;
            ////if divisible by 2 then it is primary connection trying
            if (connectionCount % 2 == 0)
                connection = $.hubConnection(EMRPracticeModel.emrurlsmodel.EMRAppServerCentralizerPrimaryURL);
                //secondary connection trying 
            else
                connection = $.hubConnection(EMRPracticeModel.emrurlsmodel.EMRAppServerCentralizerSecondaryURL);

            //connection = $.hubConnection("http://localhost:8888/");//local test purpose only

            proxy = connection.createProxy("EMRAppServerCentralizerHub");//hub is centralized hub

            //establishing the connection to the given input signalr point hub
            connection.start().fail(function (data) {

                //connection failed case
                // console.log("fail" + data);

                connectionCount = connectionCount + 1;//increasing the count

                setTimeout(function () {

                    establishConnection();//trying again to establish the connection

                }, 1000 * 5 * 60);//calling the establishment to connect after 5 mins  



            }).done(function (data) {

                //if connection established successfully subscribing for signalr requests for the current practice 

                proxy.invoke("Subscribe", EMRPracticeModel.PracticeID).done(function () {

                    //looping through the previous made requests
                    if (emrApplicationHubRequests.length > 0) {

                        for (var indexInPrevReqs = 0; indexInPrevReqs < emrApplicationHubRequests.length; indexInPrevReqs++) {

                            //if the connection is alive then we are sending the pending requests to publish over the channel
                            if (proxy.connection.state == connectionState.connected) {

                                //publish the pending requests
                                proxy.invoke("Publish", emrApplicationHubRequests[indexInPrevReqs]).done(function () {

                                });
                            }

                        }

                        emrApplicationHubRequests = [];//removing the elements after invoking the data
                    }

                });//invoking the subscribe method for the current practice for signalr requests

                connectionCount = connectionCount + 1;//increasing the count

            });


            //on disconnected event of the current connection emitting the event in home to restart the connection
            connection.disconnected(function () {
                //console.log('disconnected');

                setTimeout(function () {

                    if (connection.state == connectionState.disconnected) {
                        $rootScope.$emit("HomeCtrl.SignlrDisconnected");
                    }
                }, 1000 * 5 * 60);//calling the establishment to connect after 5 mins  


            })

        }

        establishConnection();//calling to establish the connection on first load call


        return {
            //these are the call back functions for the signalr 

            //this method is the signalr call back event for the return object
            on: function (eventName, callback) {
                proxy.on(eventName, function (result) {
                    $rootScope.$apply(function () {
                        if (callback) {
                            callback(result);
                        }
                    });
                });
            },

            //this method is useful in invoking the methods in the current signalr connection 
            invoke: function (methodName, data, callback) {

                methodName = "Publish";

                //if invoke is publish then sneding the practice id to send the data over all channels in quee list registered sending the common data to signalr
                data.practiceID = EMRPracticeModel.PracticeID;

                data.practiceName = EMRPracticeModel.PracticeName;

                data.loggedUserID = EMRPracticeModel.LoggedUserID;

                data.loggedUserName = EMRPracticeModel.FirstName + " " + EMRPracticeModel.LastName;

                data.ClientIP = EMRPracticeModel.clientIP;

                ////TESTING PURPOSE ONLY MANUALLY STOPPING THE SIGNALR 
                //if (notstoppedmanually) {
                //    //testing
                //    setTimeout(function () {

                //        proxy.invoke("Unsubscribe", EMRPracticeModel.PracticeID).done(function () {
                //            proxy.connection.stop();//stop the current signalr connection
                //            notstoppedmanually = false;
                //        });


                //    }, 3000);
                //}
                ////TESTING PURPOSE ONLY MANUALLY STOPPING THE SIGNALR 


                // if connection is active then only calling the invoke method to publish the message over the channel
                if (proxy.connection.state == connectionState.connected) {

                    proxy.invoke(methodName, data).done(function (result) {
                        $rootScope.$apply(function () {
                            if (callback) {
                                callback(result);
                            }
                        });
                    }).fail(function (resut) {
                        // console.log(resut);
                    })
                }
                else {

                    //if already in the connecting state then no need to establish the connection again!
                    if (proxy.connection.state != connectionState.connecting) {
                        establishConnection();//calling to re establish the connection
                    }

                    //if already there are some previous requests in the channel then searching for the duplicates if already exists then 
                    if (emrApplicationHubRequests.length > 0) {

                        //if already exists in array then removing the previous request and adding the latest request into the queee
                        if (emrApplicationHubRequests.findItem("EMRAppServerCentralizerActionToBePerform", data.EMRAppServerCentralizerActionToBePerform))
                            emrApplicationHubRequests.removeItem("EMRAppServerCentralizerActionToBePerform", data.EMRAppServerCentralizerActionToBePerform);//removing the data if already exists in the array

                        emrApplicationHubRequests.push(data);//pushing the data into the server failure case
                    }
                    else
                        emrApplicationHubRequests.push(data);//pushing the data into the server failure case

                }


            }
        };
    };

    return signalrHubFactory;
}]);
//############## SIGNAL- R CONNECTION ESTABLISHMENTS AND EVENT RAISING  BLOCK STARTS ##########################
